<template>
  <div class="border">
    <div class="header capitalize-all">{{ $t("title.saldosActualesPorDelegacion") }}</div>
    <div class="menu">
      <span class="drowpdown-label capitalize-all" v-if="delegationSelected">{{
        delegationSelected.desDelegacion
      }}</span>
      <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
        <template #button-content>
          <b-icon-chevron-down class="icon"></b-icon-chevron-down>
        </template>
        <b-dropdown-item-button
          v-for="delegacion of delegations"
          :key="delegacion.id"
          @click="setDelegacion(delegacion)"
          >{{ delegacion.desDelegacion }}</b-dropdown-item-button
        >
      </b-dropdown>

      <span class="drowpdown-label capitalize-all" v-if="divisaSelected">{{
        divisaSelected.codDivisa
      }}</span>
      <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
        <template #button-content>
          <b-icon-chevron-down class="icon"></b-icon-chevron-down>
        </template>
        <b-dropdown-item-button
          v-for="divisa of divisas"
          :key="divisa.id"
          @click="setDivisa(divisa)"
          >{{ divisa.codDivisa }}</b-dropdown-item-button
        >
      </b-dropdown>
    </div>

    <div class="row container">
      <line-chart :data="data"></line-chart>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

import LineChart from "@/components/common/widgets/LineChart.vue";
import { Action, Getter } from "vuex-class";
import { IDelegacion, IDivisa, LineChartData } from "@/entities";
import { ISaldoData, ISaldoParams } from "@/services";

@Component({
  components: { LineChart },
})
export default class SaldosActualesPorDelegacion extends Vue {
  @Getter("getDelegacionesCliente")
  public delegations!: IDelegacion[];
  @Getter("getClienteXDivisa")
  public divisas!: IDivisa[];
  @Action("fetchSaldos") fetchSaldosPage!: (
    params: ISaldoParams
  ) => Promise<ISaldoData | undefined>;

  public delegationSelected: IDelegacion | null = null;
  public divisaSelected: IDivisa | null = null;
  public data: LineChartData[] = [];

  mounted(): void {
    this.delegationSelected = this.delegations?.length ? this.delegations[0] : null;
    this.divisaSelected = this.divisas?.length ? this.divisas[0] : null;
    this.getSaldos();
  }

  async getSaldos(): Promise<void> {
    if (this.delegationSelected && this.divisaSelected) {
      const params: ISaldoParams = {
        pkDelegacion: [this.delegationSelected.id],
        pkDivisa: this.divisaSelected.id,
      };
      params.page = 0;
      params.size = 10;
      const response: ISaldoData | undefined = await this.fetchSaldosPage(params);
      this.data = [];
      if (response) {
        this.data.push(
          ...response.saldos.content.map((saldo) => {
            return { dateString: saldo.fecCertificado, value: saldo.saldoActual } as LineChartData;
          })
        );
      }
    }
  }

  setDelegacion(delegacion: IDelegacion): void {
    this.delegationSelected = delegacion;
    this.getSaldos();
  }

  setDivisa(divisa: IDivisa): void {
    this.divisaSelected = divisa;
    this.getSaldos();
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin-top: -6em;
}

.menu {
  margin-bottom: 10px;
}

.icon {
  width: 14px;
  color: var(--secundario-prosegur-oscuro);
  z-index: 2;
}

.drowpdown-label {
  font-size: 13px;
  line-height: 1.23;
  text-align: center;
  color: #808080;
}

.capitalize-all {
  text-transform: uppercase;
}

.header {
  margin: 0 0 10px 0;
  font-size: 14px;
  font-weight: bold;
  color: #9b9b9b;
  padding-top: 0.5rem;
}

.border {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  margin-bottom: 2rem;

  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding: 0.5rem 0 0 1rem;
  min-width: 357px;
}
</style>
